import { configureStore } from '@reduxjs/toolkit';
import ipoReducer from './slices/ipoSlice';
import uiReducer from './slices/uiSlice';
import adsReducer from './slices/adsSlice';
import gmpReducer from './slices/gmpSlice';
import ipoCatalogReducer from './slices/ipoCatalogSlice';
import subscriptionReducer, { smeSubscriptionReducer } from './slices/subscriptionSlice';
import newsReducer from './slices/newsSlice';
import upcomingIposReducer, { smeUpcomingIposReducer } from './slices/upcomingIposSlice';
import smeReviewsReducer from './slices/smeReviewsSlice';
import smeGmpReducer from './slices/smeGmpSlice';
import smeIposReducer from './slices/smeIposSlice';
import drhpReducer from './slices/drhpSlice';
import drhpFilingReducer from './slices/drhpFilingSlice';
import sebiFilingsReducer from './slices/sebiFilingsSlice';
import issueSubscriptionReducer from './slices/issueSubscriptionSlice';
import brokerReviewsReducer from './slices/brokerReviewsSlice';
import topSubscriptionReducer from './slices/topSubscriptionSlice';

export const store = configureStore({
  reducer: {
    ipo: ipoReducer,
    ui: uiReducer,
    ads: adsReducer,
    gmp: gmpReducer,
    ipoCatalog: ipoCatalogReducer,
    subscription: subscriptionReducer,
    smeSubscription: smeSubscriptionReducer,
    news: newsReducer,
    upcomingIpos: upcomingIposReducer,
    smeUpcomingIpos: smeUpcomingIposReducer,
    smeReviews: smeReviewsReducer,
    smeGmp: smeGmpReducer,
    smeIpos: smeIposReducer,
    drhp: drhpReducer,
    drhpFiling: drhpFilingReducer,
    sebiFilings: sebiFilingsReducer,
    issueSubscription: issueSubscriptionReducer,
    brokerReviews: brokerReviewsReducer,
    topSubscription: topSubscriptionReducer,
  },
});

export default store;
